import { Textarea, TextareaProps } from "@mantine/core"
import { LegacyRef } from "react";

interface CustomTextareaProps extends TextareaProps {
  ref?: LegacyRef<any> | undefined;
}

const CustomTextarea = (props: CustomTextareaProps) => (
  <Textarea
    withAsterisk={props.required}
    rows={6}
    {...props}
  />
)

export default CustomTextarea;